import { jobApiClient } from "utils";
import { JobStatus, JobStep } from "types";

export const fetchJobStatuses = async (steps: JobStep[], amount: number) => {
  let queryParams = [];
  for (const step of steps) {
    queryParams.push(`step=${step}`);
  }

  if (amount > 0) {
    queryParams.push(`amount=${amount}`);
  }
  const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
  return await jobApiClient.get<JobStatus[]>(`/jobstatus${queryString}`);
};
